<woa-field [label]="label()" [link]="link()" [message]="message()" [translationParams]="translationParams()"
           [readOnly]="readOnly()" [disabled]="disabled()" [defaultInput]="input" (onActivateLink)="onActivateLink.emit()">
    <div class="email-field">
        <input #input class="email-field-input" [attr.id]="inputId()"
               [value]="displayValue()" (input)="handleInputEvent($event)"
               type="email" [attr.autocomplete]="autocomplete()"
               [attr.maxlength]="maxlength()" spellcheck="false" [readOnly]="readOnly()"
               [attr.aria-labelledby]="labelId()" [attr.aria-describedby]="describedBy()" [attr.aria-invalid]="ariaInvalid()">
        @if (!valueSignal()) {
            <div class="email-field-placeholder">
                {{ placeholder() | translate: translationParams() }}
            </div>
        }
    </div>
</woa-field>
